export default function ComingSoonDashboard({ persona, onBack }) {
  // const label = persona ? persona.replace(/_/g, " ").toUpperCase() : "THIS";

  const label = persona?.label ?? "This";

  return (
    <div className="h-full flex items-center justify-center">
      <div className="
        max-w-md w-full
        p-8 rounded-xl
        bg-slate-900/80
        border border-slate-800
        text-center
      ">
        <h2 className="text-xl font-semibold text-gray-100">
          {label} Dashboard Coming Soon
        </h2>

        <p className="mt-3 text-sm text-gray-400">
          This role-specific dashboard will be available soon.
        </p>

        <button
          onClick={onBack}
          className="
            mt-6 px-4 py-2
            rounded-md
            border border-slate-700
            bg-slate-900/70
            text-sm text-gray-200
            hover:border-accent-action/60
            hover:text-white
            transition
          "
        >
          Back to Dashboards
        </button>
      </div>
    </div>
  );
}